import React, { useMemo } from 'react';
import { useImageHandler } from 'utils/custom_hooks';

const CourseOrganizerImage = ({ courseOrganizer }) => {
  const memoizedOptionList = useMemo(
    () => [courseOrganizer.logo, courseOrganizer.companyLogo],
    [courseOrganizer.logo, courseOrganizer.companyLogo]
  );
  const { currentImage, handleImageToDefault } = useImageHandler({
    optionList: memoizedOptionList,
    data: courseOrganizer,
  });

  return (
    <div className="category-card-user-picture-container d-lg-none mt-0 mt-md-4 mt-lg-0">
      <img
        className="category-card-user-picture"
        // style={{borderRadius: "50%"}}
        src={currentImage}
        onError={() => handleImageToDefault()}
        alt={courseOrganizer.name}
      />
    </div>
  );
};

export default CourseOrganizerImage;
